import React, { useState, useEffect, useRef } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { Magic } from 'magic-sdk'
import { OAuthExtension } from '@magic-ext/oauth'
import { Spinner } from 'baseui/spinner'
import axios from 'axios'
import Cookies from 'js-cookie'
import { reactLocalStorage } from 'reactjs-localstorage'
import { useRouter } from 'next/router'

import { useRecoilValue, useRecoilCallback, useRecoilState } from 'recoil'
import { publicIsLoggedIn, currentTemplateID } from '@/store/onepager/onepager'

import { contentIds, content, content_block } from '@/store/template/content'

function SignUpModal({
  collection,
  onepager,
  closeModal,
  onSignUp,
  isOnepagerForm,
}) {
  const contents = useRecoilValue(contentIds)
  const getCurrentTemplateId = useRecoilValue(currentTemplateID)

  const [email, setEmail] = useState('')
  const [consent, setConsent] = useState(true)
  const [loading, setLoading] = useState(false)
  const [emailError, setEmailError] = useState(false)

  const [getLoggedInState, setLoggedInState] = useRecoilState(publicIsLoggedIn)

  const router = useRouter()

  const loginWithMagic = async () => {
    if (validateEmail(email)) {
      setLoading(true)
      setEmailError(false)

      // white label by default
      // set cookie wl-email for subdomain.domain
      Cookies.set('wl-email', email, { expires: 14 })
      Cookies.set('wl-submissionConsent', consent, { expires: 14 })

      const subdomainFromURL = window.location.host.split('.')[1]
        ? window.location.host.split('.')[0]
        : false

      const signUpAndCheckContent = await axios.post(
        '/api/rest/signup-email-and-get-content',
        {
          email: email,
          collectionId: collection._id,
          templateId: findGetParameter('i'),
          template_title: onepager.title,
          template_desc: onepager.description,
          subdomain: subdomainFromURL,
        }
      )

      if (signUpAndCheckContent.data) {
        // only refresh if content is not empty
        if (signUpAndCheckContent.data.content.length > 0) {
          refreshStore(signUpAndCheckContent.data)
        } else {
          // does not have content - malformed content
        }
      }

      // Trigger Save To Account
      const saveToAccountOnSignUp = await axios.post(
        '/api/save-to-account/save',
        {
          email: email,
          collectionId: collection._id,
          templateId: findGetParameter('i'),
          template_title: onepager.title,
          template_desc: onepager.description,
          subdomain: subdomainFromURL,
        }
      )

      // remove shareId from URL

      if (router.pathname !== '/[url]') {
        var newurl =
          window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname +
          '?i=' +
          findGetParameter('i')
        window.history.pushState({ path: newurl }, '', newurl)
      } else {
        var newurl =
          window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname
        window.history.pushState({ path: newurl }, '', newurl)
      }

      // check if webhook
      if (onepager?.webhook_url) {
        try {
          await axios.get(
            `https://zeplo.to/${onepager.webhook_url}?_token=2DBvjKBZDVO4V9RqwjcK1d5cavCiUG1fT2olx7&email=${email}`
          )
        } catch {
          // don't catch any errors for now...
        }
      }

      setLoggedInState(true)
      setLoading(false)
      setEmailError(false)
      closeModal()
      onSignUp()
    } else {
      setEmailError(true)
    }
  }

  const refreshStore = useRecoilCallback(
    ({ template, set }) =>
      async template => {
        // build contents
        // let allContentIds = []
        _.forEach(template.content, function (contentData) {
          // allContentIds.push(contentData.id)
          set(content(contentData.id), contentData.atom)
        })
        // set(contentIds, allContentIds)

        //build content_blocks
        _.forEach(template.content_blocks, function (contentBlockData) {
          set(content_block(contentBlockData.id), contentBlockData.atom)
        })
      }
  )

  async function saveToAccount() {
    const saveCollectionToAccount = await axios.post(
      '/api/rest/save-collection-to-account',
      {
        userId: Cookies.get('authed-user-id'),
        collectionId: collection._id,
      }
    )
  }

  const saveContentState = useRecoilCallback(({ snapshot }) => async () => {
    // console.log('saveContentState?')

    // build content json
    const contentsDB = []

    _.forEach(contents, function (contentID, index) {
      const contentAtom = snapshot.getLoadable(content(contentID)).contents
      contentsDB.push({ id: contentID, atom: contentAtom })
    })

    // build contentBlocks json
    const contentBlocksDB = []

    _.forEach(contentsDB, function (contentItem, index) {
      // check if content has .blocks array
      if (contentItem.atom.blocks) {
        // loop through each block, get by ID, and store in contentBlocksDB
        _.forEach(contentItem.atom.blocks, function (contentBlockID, index) {
          const contentBlockAtom = snapshot.getLoadable(
            content_block(contentBlockID)
          ).contents
          contentBlocksDB.push({ id: contentBlockID, atom: contentBlockAtom })
        })
      }
    })

    if (isOnepagerForm) {
      const updateUserContent = await axios.post(
        '/api/rest/save-user-content-email',
        {
          email: Cookies.get('submission-email'),
          templateId: getCurrentTemplateId,
          content: JSON.stringify({
            content: contentsDB,
            content_blocks: contentBlocksDB,
          }),
        }
      )
    } else {
      const updateUserContent = await axios.post(
        '/api/rest/save-user-content',
        {
          userID: Cookies.get('authed-user-id'),
          templateId: getCurrentTemplateId,
          content: JSON.stringify({
            content: contentsDB,
            content_blocks: contentBlocksDB,
          }),
        }
      )
    }
  })

  function loginOnEnter(e) {
    if (e.key === 'Enter') {
      e.preventDefault()
      loginWithMagic()
    }
  }

  function validateEmail(email) {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
  }

  function findGetParameter(parameterName) {
    var result = null,
      tmp = []
    location.search
      .substr(1)
      .split('&')
      .forEach(function (item) {
        tmp = item.split('=')
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1])
      })

    if (parameterName == 'i') {
      // check if it its a [url] page
      if (result) {
        return result
      } else {
        let getURL = router.query.url
        getURL = getURL.split('-')
        getURL = getURL.pop()
        return getURL
      }
    } else {
      // shareID or something else
      return result
    }
  }

  return (
    <div
      className="fixed top-0 left-0 w-full h-full  z-50 flex flex-col justify-center items-center"
      style={{ zIndex: 9999999 }}
    >
      <motion.div
        initial="hidden"
        animate="visible"
        exit="exit"
        transition={{ duration: 0.15 }}
        variants={{
          hidden: {
            opacity: 0,
          },
          visible: {
            opacity: 1,
          },
          exit: {
            opacity: 0,
          },
        }}
        style={{ zIndex: 9999999 }}
        onClick={() => {
          closeModal()
        }}
        className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-75 cursor-pointer"
      ></motion.div>
      <motion.div
        initial="hidden"
        animate="visible"
        exit="exit"
        transition={{ duration: 0.15 }}
        variants={{
          hidden: {
            opacity: 0,
            scale: 0.9,
          },
          visible: {
            opacity: 1,
            scale: 1,
          },
          exit: {
            opacity: 0,
            scale: 0.9,
          },
        }}
        className="bg-white rounded shadow-xl max-w-md p-10 relative z-10"
        style={{ minWidth: '400px', zIndex: 99999999 }}
      >
        {loading && (
          <div className="absolute top-0 left-0 h-full w-full bg-white  flex flex-col items-center justify-center">
            <Spinner color="#ffc900" />
            <h3 className="mt-5 text-2xl font-bold text-center">
              {!isOnepagerForm && <span className="">Loading...</span>}
              {isOnepagerForm && (
                <span className="">Saving & Submitting...</span>
              )}
            </h3>
          </div>
        )}

        {!isOnepagerForm && (
          <div>
            <h2 className="text-4xl font-bold text-center appTitleItem">
              Enter in Your Email
            </h2>
            <p className="text-lg mt-2 text-center">
              Save Your Copy To Your Existing Account or Automatically Sign Up
              For a Free Account.
            </p>
          </div>
        )}

        {/* {collection.promoted && (
          <div>
            <h2 className="text-4xl font-bold text-center appTitleItem">
              Sign Up
            </h2>
            <p className="text-lg mt-5 text-center">
              Create Onepager Account, and Keep Your Edits
            </p>
          </div>
        )} */}

        {isOnepagerForm && (
          <div>
            <p className="text-3xl font-bold mt-0 text-center appTitleItem">
              Enter in Your Email To Submit & Save
            </p>
          </div>
        )}

        <div className="mt-5">
          {emailError && (
            <div className="p-2 rounded bg-yellow-200  font-medium mb-5 text-center">
              Opps! Issue with email format - try again! :)
            </div>
          )}

          <input
            autoFocus
            value={email}
            onChange={e => {
              let emailLower = e.target.value
              setEmail(emailLower.toLowerCase())
            }}
            onKeyDown={loginOnEnter}
            className="text-xl text-center font-medium border-2 border-black shadow-inner mb-2   block w-full p-5"
            type="text"
            type="email"
            placeholder="Enter Your Email Address..."
          />
          <button
            onClick={loginWithMagic}
            className="block p-5 text-2xl font-bold bg-black w-full text-white"
          >
            {isOnepagerForm && <span>Submit & Save Your Changes</span>}
            {!isOnepagerForm && <span>Save Changes</span>}
          </button>

          <label
            name="shareData"
            className="border hidden p-2 pr-3 rounded my-2 text-sm block cursor-pointer"
          >
            <div className=" flex items-center">
              <input
                type="checkbox"
                name="shareData"
                className="mr-2"
                checked={consent}
                onChange={e => {
                  setConsent(e.target.checked)
                }}
              />
              <span className="font-medium">
                Share my data with the owner of this OnePager.
              </span>
            </div>
          </label>

          <div
            onClick={() => {
              window.open('https://onepager.io', '_blank')
              analytics.track('Copy Onepager Link in Signup Popup')
            }}
            className="mt-5 flex justify-center cursor-pointer hover:opacity-75"
          >
            <span className="flex  items-center rounded ">
              <img
                className="h-6 w-6 "
                src="https://cdn.filestackcontent.com/jW9hY5L5RAWWpn2rGhw9"
              />
              <span className=" font-bold ml-3">onepager.io</span>
            </span>
          </div>

          <p className="text-center opacity-75 text-xs mt-3">
            By signing up you are creating a free OnePager account (or added to
            your account) to edit and tweak your page at anytime following the{' '}
            <a
              href="https://onepager.io/terms-conditions"
              className="font-medium text-blue-600"
              target="_blank"
            >
              terms
            </a>{' '}
            and{' '}
            <a
              href="https://onepager.io/privacy-policy"
              className="font-medium text-blue-600"
              target="_blank"
            >
              privacy
            </a>{' '}
            policy &amp; conditions.
          </p>

          {/* {!isOnepagerForm && (
            <p className="text-center text-sm mt-3">
              If you don't have a onepager account, we will create one for you.
            </p>
          )} */}
        </div>
      </motion.div>
    </div>
  )
}

export default SignUpModal
